import { DialogTag } from '@pixelgenau/ngx-dialog';

export const SearchAboTag = new DialogTag<void, boolean>(
    'search-abo-dialog',
    () => import('./search-abo-overlay.component'),
);
